/**
 * Client-side document title + meta description for SPA routes.
 * Crawlers that execute JS (Google) see updates; index.html defaults cover others.
 */

const BRAND = 'CR7 Myanmar';

const DEFAULT_DESCRIPTION =
  'CR7 — Myanmar online slots, fishing hunter games, live casino, Pragmatic & PG Soft slots, Shan Koe Mee (ရှမ်းကိုမီး), BuGyee (ဗျီး), Galone Galone, Forest Party, 2D/3D & arcade. Play slot games, card tables & fishing games built for Myanmar players.';

/** @type {Record<string, { title: string; description: string }>} */
const BY_PATH = {
  '/': {
    title: `${BRAND} | Slots, Fishing, Shan Koe Mee & BuGyee`,
    description: DEFAULT_DESCRIPTION,
  },
  '/home': {
    title: `${BRAND} | Slots, Fishing, Shan Koe Mee & BuGyee`,
    description: DEFAULT_DESCRIPTION,
  },
  '/slots': {
    title: `Online Slot Games | ${BRAND}`,
    description:
      'Play online slots in Myanmar: Pragmatic Play, PG Soft & top providers. CR7 slot lobby — spin fishing-themed slots, classic reels & jackpots on mobile or web.',
  },
  '/fishing': {
    title: `Fishing Hunter Games | ${BRAND}`,
    description:
      'Myanmar fishing games & fish hunter arcades — shoot fish for prizes, multiplayer tables & fast sessions. CR7 fishing game lobby for Myanmar players.',
  },
  '/promotion': {
    title: `Promotions & Bonuses | ${BRAND}`,
    description:
      'CR7 promotions for Myanmar: deposit bonuses, slot & fishing rebates, VIP rewards, Shan Koe Mee & BuGyee promos. Check latest casino-style offers.',
  },
  '/live': {
    title: `Live Casino & Live Games | ${BRAND}`,
    description:
      'Live dealer and live game tables on CR7 for Myanmar — baccarat, roulette-style streams & card games alongside slots and fishing titles.',
  },
  '/deposit': {
    title: `Deposit | ${BRAND}`,
    description:
      'Fast deposits on CR7 Myanmar — top up to play slots, fishing games, Shan Koe Mee, BuGyee & live tables. Secure payment methods for Myanmar players.',
  },
  '/withdraw': {
    title: `Withdraw | ${BRAND}`,
    description:
      'Withdraw winnings from CR7 — slots, fishing, Shan Koe Mee & BuGyee balances. Myanmar-focused payout flow & saved bank or wallet details.',
  },
  '/banking': {
    title: `Bank & Wallet Details | ${BRAND}`,
    description:
      'Save or update your Myanmar bank or e-wallet on CR7 for withdrawals after slots, fishing games, Shan Koe Mee & BuGyee play.',
  },
  '/history': {
    title: `Transaction History | ${BRAND}`,
    description:
      'View deposits, withdrawals & game balance history on CR7 Myanmar — slots, fishing, Shan Koe Mee & BuGyee activity in one place.',
  },
  '/setting': {
    title: `Account Settings | ${BRAND}`,
    description:
      'Manage your CR7 profile, language, password & preferences for Myanmar online slots, fishing games & card rooms.',
  },
  '/contact-us': {
    title: `Contact Support | ${BRAND}`,
    description:
      'Contact CR7 support for Myanmar — slots, fishing games, Shan Koe Mee, BuGyee & account help.',
  },
  '/commission': {
    title: `Commission & Referrals | ${BRAND}`,
    description:
      'CR7 commission program for Myanmar agents & players — earn from referrals in slots, fishing & card games.',
  },
  '/level': {
    title: `VIP Levels | ${BRAND}`,
    description:
      'CR7 VIP tiers for Myanmar players — unlock rewards as you play slots, fishing games, Shan Koe Mee & BuGyee.',
  },
  '/video-links': {
    title: `Videos & Guides | ${BRAND}`,
    description:
      'CR7 video links & guides for Myanmar — how to play slots, fishing games, Shan Koe Mee & BuGyee.',
  },
  '/rule': {
    title: `Rules & Terms | ${BRAND}`,
    description:
      'CR7 rules, fair play & terms for Myanmar online gaming — slots, fishing, Shan Koe Mee & BuGyee.',
  },
  '/auth/login': {
    title: `Login | ${BRAND}`,
    description:
      'Log in to CR7 Myanmar — online slots, fishing hunter games, Shan Koe Mee, BuGyee & live casino in one account.',
  },
  '/auth/register': {
    title: `Register | ${BRAND}`,
    description:
      'Create a CR7 account for Myanmar — play online slots, fishing games, Shan Koe Mee (ရှမ်းကိုမီး), BuGyee (ဗျီး) & more. Quick sign-up.',
  },
  '/user/slots': {
    title: `Slot Lobby | ${BRAND}`,
    description:
      'CR7 slot lobby for Myanmar — Pragmatic, PG Soft & more. Online slot games, jackpots & mobile-friendly spins.',
  },
  '/user/fishing': {
    title: `Fishing Game Lobby | ${BRAND}`,
    description:
      'Fish hunter & fishing arcade lobby on CR7 for Myanmar — multiplayer shooting fish games and fast rounds.',
  },
  '/user/arcade': {
    title: `Arcade Games | ${BRAND}`,
    description:
      'Arcade & casual games on CR7 Myanmar — beside slots and fishing, quick skill & luck titles.',
  },
  '/user/game': {
    title: `Game Lobby | ${BRAND}`,
    description:
      'Browse CR7 game lobby — Myanmar slots, fishing, card games & providers in one hub.',
  },
  '/user/skm-rooms': {
    title: `Shan Koe Mee Online | ${BRAND}`,
    description:
      'Play Shan Koe Mee (ရှမ်းကိုမီး) online on CR7 — Myanmar Shan card game rooms, real-time tables & stakes.',
  },
  '/user/bugyee-rooms': {
    title: `BuGyee Card Game Online | ${BRAND}`,
    description:
      'BuGyee (ဗျီး) online rooms on CR7 — Myanmar BuGyee card game tables, multiplayer & classic rules.',
  },
  '/user/2d': {
    title: `2D Lottery | ${BRAND}`,
    description:
      'CR7 2D lottery & numbers for Myanmar players — alongside slots, fishing & card games.',
  },
  '/user/2d/home': {
    title: `2D Home | ${BRAND}`,
    description:
      '2D lottery home on CR7 Myanmar — quick access to results & bets with your gaming wallet.',
  },
  '/user/3d': {
    title: `3D Lottery | ${BRAND}`,
    description:
      'CR7 3D lottery for Myanmar — number games with slots, fishing & Shan Koe Mee on one platform.',
  },
  '/user/3d/home': {
    title: `3D Home | ${BRAND}`,
    description:
      '3D lottery hub on CR7 Myanmar — results, play & wallet in one place.',
  },
};

const PREFIX_FALLBACKS = [
  { test: /^\/user\/slots/, key: '/user/slots' },
  { test: /^\/user\/fishing/, key: '/user/fishing' },
  { test: /^\/user\/skm-rooms/, key: '/user/skm-rooms' },
  { test: /^\/user\/bugyee-rooms/, key: '/user/bugyee-rooms' },
  { test: /^\/user\/2d\/home/, key: '/user/2d/home' },
  { test: /^\/user\/2d/, key: '/user/2d' },
  { test: /^\/user\/3d\/home/, key: '/user/3d/home' },
  { test: /^\/user\/3d/, key: '/user/3d' },
];

/**
 * @param {import('vue-router').Route} to
 */
export function applyRouteDocumentSeo(to) {
  const path = to.path.split('?')[0] || '/';
  let entry = BY_PATH[path];
  if (!entry) {
    for (const { test, key } of PREFIX_FALLBACKS) {
      if (test.test(path)) {
        entry = BY_PATH[key];
        break;
      }
    }
  }
  if (!entry) {
    entry = {
      title: `${BRAND} | Myanmar Slots, Fishing & Card Games`,
      description: DEFAULT_DESCRIPTION,
    };
  }

  document.title = entry.title;

  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'description');
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', entry.description);
}
